import "./CsaPage.css";
import Hero from "../components/Hero";
import CTAHero from "../components/CTAHero";
import InfoCard from "../components/InfoCard";
import CsaCardBody from "../components/CsaCardBody";
import { CSAInfoCards } from "../utils/csaPage.helpers";
import CsaBoxCardBody from "../components/CsaBoxCardBody";
import { useEffect, useState } from "react";
import {
  fetchSubscriptionBoxes,
  type SubscriptionBoxContentfulItem,
} from "../api/contentful";

export type SubscriptionBox = {
  title: string;
  image: string;
  description: string[];
};

const transformToSubscriptionBoxes = (
  items: SubscriptionBoxContentfulItem[],
): SubscriptionBox[] => {
  return items.map((item) => ({
    title: item.fields.title,
    image: item.fields.image.fields.file.url,
    description: item.fields.description,
  }));
};
const CsaPage: React.FC = () => {
  const [subscriptionBoxList, setSubscriptionBoxList] = useState<SubscriptionBox[]>([]);
  const csaInfoCards = CSAInfoCards.map((card, index) => {
    return (
      <InfoCard
        key={index + card.altText}
        image={card.image}
        altText={card.altText}
        color="green"
        body={<CsaCardBody title={card.body.title} text={card.body.text} />}
      />
    );
  });
  const offeredBoxes =
    subscriptionBoxList &&
    subscriptionBoxList.map((item: SubscriptionBox) => {
      const { title, image, description } = item;
      return (
        <InfoCard
          key={title}
          image={image}
          altText={title}
          color="beige"
          body={<CsaBoxCardBody title={title} text={description} />}
        />
      );
    });

  useEffect(() => {
    const fetchSubscriptionBoxesData = async () => {
      const { items } = await fetchSubscriptionBoxes();
      const subscriptionBoxes = transformToSubscriptionBoxes(items);
      setSubscriptionBoxList(subscriptionBoxes);
    };

    fetchSubscriptionBoxesData();
  }, []);
  return (
    <>
      <Hero page="csa" titleTwo="Community supported agriculture" />
      <div className="hero-introduction-wrapper csa-extra-space">
        <div className="hero-introduction-container">
          <div className="hero-introduction">
            <p>
              More than vegetables, CSA is about trust and solidarity. You
              invest in your local farm, eat with the seasons, and help create a
              food system that is good for the planet and everyone who lives in
              there.
            </p>
          </div>
        </div>
      </div>
      <div className="content-container csa-container">
        <div className="csa-grid">
          <div className="info-card green csa-info-container csa-grid-item1">
            <h2>What is CSA</h2>
            <p>
              Subscription-based way to receive{" "}
              <span className="csa-highlight">
                the freshest, most local vegetables possible
              </span>
              . For 21 weeks during the growing season, you get a weekly "share"
              of seasonal and diverse produce while building a close connection
              with the farmers who grow your food. - By joining, you support{" "}
              <span className="csa-highlight">
                biodiversity, environmental care, community building and a
                healthier way of eating.
              </span>
            </p>
          </div>
          <div className="wrapper-card yellow csa-info-container csa-grid-item2">
            <h2>What we offer</h2>

            <div className="csa-boxes csa-boxes-offer-container">
              {offeredBoxes}
            </div>
          </div>
          <div className="csa-grid-item6">
            <CTAHero
              textColor="green"
              background="green"
              linkText="I want my box!"
              link="/csa-signup"
              xl={false}
            />
          </div>
          <div className="csa-infocard-container csa-grid-item3">
            {csaInfoCards}
          </div>
          <div className="csa-grid-item4">
            <CTAHero
              textColor="red"
              background="image"
              linkText="Sign Me Up!"
              link="/csa-signup"
              xl={false}
            />
          </div>
          <div className="csa-grid-item7">
            <CTAHero
              xl={true}
              textColor="yellow"
              background="yellow"
              title={`Apply quickly to ensure your spot during the application period.
            Availability is limited.
            Previous CSA members will be given the chance to apply early.`}
            />
          </div>
          <div className="info-card csa-info-container csa-grid-item5">
            <h2>Community</h2>

            <div className="csa-boxes csa-boxes-community-container">
              <div className="info-card csa-boxes-community ">
                <h4>Student/Low Income Box</h4>
                <ul>
                  <li>Applies only to chosen boxes</li>
                  <li>20% reduced price</li>
                  <li>Spaces depend on amount of Solidarity Boxes</li>
                </ul>
              </div>
              <div className="info-card csa-boxes-community ">
                <h4>Solidarity Box</h4>
                <ul>
                  <li>Applies only to chosen boxes</li>
                  <li>
                    20% higher price to balance the Student/Low Income Box
                  </li>
                  <li>
                    This box makes sure more people on a lower budget, can also
                    enjoy this project.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CsaPage;
